// extracted by mini-css-extract-plugin
export default {"ActiveCard":"PostBox_ActiveCard__7H8Sj"};